export default __webpack_public_path__ + "static/media/plusOutlineWhite.37664969.svg";